import { createContext, useContext, useState } from "react";


const MenuContext = createContext()

export default function MenuContextProvider(props){
  const [MenuBoxState, SetMenuBoxState] = useState("MenuBoxDashboardMenu");
  const [MenuPageIndex, SetMenuPageIndex] = useState(0);

  return(
    <MenuContext.Provider
      value={{
        MenuBoxState, SetMenuBoxState,
        MenuPageIndex, SetMenuPageIndex
      }}
    >
      {props.children}
    </MenuContext.Provider>
  )
}

export function useMenuContext(){
  const context = useContext(MenuContext)
  if(!context) throw console.error("The useMenubarContext need insize in MenuContextProvider ");
  const {
    MenuBoxState, SetMenuBoxState,
    MenuPageIndex, SetMenuPageIndex 
  } = context;
  return { 
    MenuBoxState, SetMenuBoxState,
    MenuPageIndex, SetMenuPageIndex
  }
}